import { type AxiosRequestConfig } from 'axios'

const getUserById = (id?: string): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: `/users/${id}`
  }
}

export { getUserById }
